import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge tailwind classes — clsx for conditionals, tailwind-merge for de-dup. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
